import { render } from "./GateControl.vue?vue&type=template&id=8f1f398a&scoped=true"
import script from "./GateControl.vue?vue&type=script&lang=js"
export * from "./GateControl.vue?vue&type=script&lang=js"

import "./GateControl.vue?vue&type=style&index=0&id=8f1f398a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f1f398a"]])

export default __exports__